import { render } from "./ConnectionRow.vue?vue&type=template&id=4ae8ffd2&ts=true"
import script from "./ConnectionRow.vue?vue&type=script&lang=ts"
export * from "./ConnectionRow.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__